export abstract class MarketConfigurable<T> {
    protected abstract readonly config: Record<string, T>;

    protected getConfigByMarketCode(marketCode: string): Record<string, any> {
        return this.config[marketCode] || this.config.default || {};
    }
}
